import { boolean } from 'yup';
import { FieldType } from '@widgets/EnquiryForm/types/config';
export const generateCaptchaSchemaObject = ({ type }) => {
    if (type !== FieldType.Captcha)
        return null;
    return boolean().isTrue();
};
